import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router';
import { useSelector } from 'react-redux';

// Import your assets
import logoWhite from '../../assets/images/Logo.png';
import loadingGif from '../../assets/images/loader.gif';

import stripeApiService from '../../services/stripe-subscription.service';
import IndividualRegister from './IndividualRegister/IndividualRegister';
import BusinessRegister from './BusinessRegister/BusinessRegister';

function Register() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const subscriptionPlanFromUrl = searchParams.get('subscriptionPlan');
  const [signInType, setSignInType] = useState(null);

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/landing');
    }
  }, [isAuthenticated, navigate]);

  useEffect(() => {
    const checkSubscriptionPlan = async (subscriptionPlanFromUrl) => {
      setIsLoading(true);

      if (!subscriptionPlanFromUrl) {
        setSignInType('BUSINESS');
        setIsLoading(false);
        return;
      }

      try {
        const priceValidationResult = await stripeApiService.validatePrice(
          subscriptionPlanFromUrl,
        );

        if (!priceValidationResult?.is_price_valid) {
          navigate('/error-page');
          return;
        }

        // Set the sign-in type based on the validation response
        setSignInType(priceValidationResult.user_signin_type);
      } catch (error) {
        navigate('/error-page');
      } finally {
        setIsLoading(false);
      }
    };

    checkSubscriptionPlan(subscriptionPlanFromUrl);
  }, [subscriptionPlanFromUrl, navigate, setSignInType]);

  const renderRegistrationForm = () => {
    if (isLoading) {
      return (
        <div className="d-flex justify-content-center align-items-center h-100">
          <div>
            <img
              width={240}
              src={loadingGif}
              alt="Loading..."
              className="loader-gif"
            />
          </div>
        </div>
      );
    }

    switch (signInType) {
      case 'INDIVIDUAL':
        return <IndividualRegister priceID={subscriptionPlanFromUrl} />;
      case 'BUSINESS':
        return <BusinessRegister priceID={subscriptionPlanFromUrl} />;
      default:
        return (
          <div className="text-center">
            <p>Invalid registration type. Please try again.</p>
          </div>
        );
    }
  };

  return (
    <div className="prelogin-container w-full">
      <div className="flex flex-col lg:flex-row min-h-screen">
        <div className="w-full lg:w-1/2 p-0">
          <div className="prelogin-leftside">
            <div className="container fix-height">
              <img className="logo-large" src={logoWhite} alt="logo white" />
              <div className="text">
                <h1 className="tagline-large">
                  Empowering healthcare providers with real-time prescription
                  coverage clarity
                </h1>
              </div>
            </div>
          </div>
        </div>
        <div className="w-full lg:w-1/2 p-0 bg-white">
          <div className="prelogin-rightside register-form">
            <div className="p-5">
              {renderRegistrationForm()}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Register;
